import {memo} from 'react';
import TextField from '@material-ui/core/TextField';
import {
  INPUT_FIELDS,
  REQUIRED_FIELD_MESSAGE,
} from 'packages/constants/constants';
import {useFormContext} from 'react-hook-form';
import {useQuery} from '@apollo/client';
import {User} from 'packages/common-types/schema-types';
import FormSelect from 'packages/common-ui/FormSelect';
import {VALIDATE_USER_INFORMATION} from 'packages/graphql/v2/queries';
import {FormNames, IRegisterForm} from 'packages/common-types/base-types';

type ValidationVars = {
  find: string;
};
type ValidationData = {
  validateUserInformation: User;
};

const FormPersonalInfo = memo(() => {
  const {register, errors, control} = useFormContext<IRegisterForm>();
  const {refetch: validateField} = useQuery<ValidationData, ValidationVars>(
    VALIDATE_USER_INFORMATION,
    {
      skip: true,
    }
  );

  return (
    <>
      <TextField
        autoComplete="only-password"
        variant="outlined"
        margin="dense"
        fullWidth
        type="text"
        label="Nombre completo"
        name="fullName"
        inputRef={register({
          required: {
            message: REQUIRED_FIELD_MESSAGE,
            value: true,
          },
        })}
        error={errors?.fullName && true}
        helperText={errors.fullName && errors.fullName.message}
      />
      <TextField
        autoComplete="only-password"
        variant="outlined"
        fullWidth
        margin="dense"
        type="email"
        label="Correo electrónico"
        name="email"
        inputRef={register({
          required: {
            message: 'Este campo es requerido',
            value: true,
          },
          validate: {
            unique: async (value) => {
              let isValid = true;
              try {
                const {data} = await validateField({find: value});
                isValid = !data?.validateUserInformation;
              } catch (error) {
                console.error(error);
              }
              return isValid
                ? true
                : 'Este correo electrónico ya fue registrado';
            },
          },
        })}
        error={errors.email && true}
        helperText={errors.email && errors.email.message}
      />

      <TextField
        autoComplete="only-password"
        variant="outlined"
        fullWidth
        margin="dense"
        type="number"
        label="Número de teléfono"
        name="phoneNumber"
        inputRef={register({
          required: {
            message: REQUIRED_FIELD_MESSAGE,
            value: true,
          },
          validate: {
            unique: async (value) => {
              let isValid = true;
              try {
                const {data} = await validateField({find: value});
                isValid = !data?.validateUserInformation;
              } catch (error) {
                console.error(error);
              }
              return isValid
                ? true
                : 'Este número de teléfono ya fue registrado';
            },
          },
        })}
        error={errors.phoneNumber && true}
        helperText={errors.phoneNumber && errors.phoneNumber.message}
      />

      <FormSelect
        className=""
        name="gender"
        control={control}
        defaultValue=""
        rules={{
          required: {
            value: true,
            message: 'Este campo es requerido',
          },
        }}
        selectProps={{
          id: INPUT_FIELDS[FormNames.GENDER].id,
          label: INPUT_FIELDS[FormNames.GENDER].label,
          options: INPUT_FIELDS[FormNames.GENDER].options,
          placeholder: INPUT_FIELDS[FormNames.GENDER].placeholder,
          errorMessage:
            errors[FormNames.GENDER] && errors[FormNames.GENDER].message,
        }}
      />
    </>
  );
});

FormPersonalInfo.displayName = 'FormPersonalInfo';

export default FormPersonalInfo;
